import React from "react";

import { formatDate } from "../../../../../../utils/DateHelpers";
import NewDatePicker from "../../../../../shared/forms/DatePicker";

const DatePicker = ({
    value,
    onChange,
    minDate,
    maxDate,
    isAvailable,
    label,
}) => {
    const onDateChanged = (date) => {
        onChange(formatDate(date));
    };

    return (
        <NewDatePicker
            value={value !== "" ? new Date(value) : value}
            onChange={onDateChanged}
            filterDate={isAvailable}
            maxDate={maxDate}
            minDate={minDate}
            label={label}
        />
    );
};

export default DatePicker;
